import { Color } from '@/types'
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from '../base/badge'

type BadgeColor = BaseBadgeProps['color']

type EventContactType = {
  name: string
  color: BadgeColor | Color
}

interface BadgeProps {
  eventContact: EventContactType
}

export const Badge = ({ eventContact }: BadgeProps) => {
  const { color, name } = eventContact

  return <BaseBadge color={color?.toLowerCase() as BadgeColor}>{ name }</BaseBadge>
}
